import { JsonRpcProvider } from 'ethers';
import { getApi3RpcUrls } from '../utils/utils';

export const PURCHASE_TEST_CHAIN = {
  id: 1,
  name: 'Ethereum',
  alias: 'ethereum',
  rpcUrl: getApi3RpcUrls(1)[0],
};

export const IS_PURCHASE_TEST = localStorage.getItem('test-purchase') === 'true';

export const PURCHASE_TEST_PROVIDER = new JsonRpcProvider(PURCHASE_TEST_CHAIN.rpcUrl);
